// Create a new file: src/components/EmptyState/EmptyState.tsx
import React from 'react';
import { Box, Typography, styled } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const EmptyStateContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(8, 4),
  textAlign: 'center',
  minHeight: '300px',
}));

const IconContainer = styled(Box)(({ theme }) => ({
  width: '80px',
  height: '80px',
  borderRadius: '50%',
  backgroundColor: theme.palette.grey[100],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  border: `2px solid ${theme.palette.grey[300]}`,
}));

const StyledInfoIcon = styled(InfoIcon)(({ theme }) => ({
  fontSize: '2.5rem',
  color: theme.palette.grey[500],
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
}));

const Description = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: theme.palette.text.secondary,
  maxWidth: '500px',
  lineHeight: 1.6,
}));

interface EmptyStateProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = "This folder is currently empty",
  description = "Get started with the '+ Add new' button to add content to this folder, or upload any pre-existing templates you have.",
  icon
}) => {
  return (
    <EmptyStateContainer>
      <IconContainer>
        {icon || <StyledInfoIcon />}
      </IconContainer>
      <Title variant="h5">
        {title}
      </Title>
      <Description variant="body1">
        {description}
      </Description>
    </EmptyStateContainer>
  );
};

export default EmptyState;